module.exports = __webpack_public_path__ + "img/PK.5a7e8e07.svg";